import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/categories/[Id]/CategoryDetailPageClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Shared/Loading/styles.module.scss");
